import React, { useEffect } from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import LoginMode from '../../Types/LoginMode';
import LoginChangePassword from './ui/LoginChangePassword';
import LoginForgotPassword from './ui/LoginForgotPassword';
import LoginForm from './ui/LoginForm';
import LoginSelectOrganization from './ui/LoginSelectOrganization';
import LoginRegisterAccount from './ui/LoginRegisterAccount';
import LoginTypeSelector from './LoginTypeSelector';
import { triggerToast } from '../../Services/Toast.service';
import { translate } from '../../Services/translation';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import { setLoginError } from '../../Actions/Login.action';

const LoginContainer = () => {
  const { loginMode, error, b2bUrl, b2cUrl } = useTypedSelector(
    (state) => state.login
  );
  const dispatch = useTypedDispatch();

  useEffect(() => {
    if (error) {
      triggerToast({
        type: 'error',
        title: translate('general.error'),
        text: error,
        autoClose: false
      });
      dispatch(setLoginError(undefined));
    }
  }, [error]);

  return (
    <>
      {loginMode == LoginMode.Login && (!!b2bUrl || !!b2cUrl) && (
        <LoginTypeSelector />
      )}
      {loginMode == LoginMode.Login && <LoginForm error={error} />}
      {loginMode == LoginMode.SelectOrganization && (
        <LoginSelectOrganization />
      )}
      {loginMode == LoginMode.ChangePassword && <LoginChangePassword />}
      {loginMode == LoginMode.ForgotPassword && <LoginForgotPassword />}
      {loginMode == LoginMode.RegisterAccount && <LoginRegisterAccount />}
    </>
  );
};

export default LoginContainer;
